import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;
  justify-items: center;

  .courseFooter {
    display: flex;
    justify-content: space-between; /* This will spread the child elements */

    margin-top: 2rem;
  }

  .project-links {
    display: flex;
    align-items: center;
    gap: 1rem;
    text-align: right;
  }
  a > img {
    width: 5rem;
  }

  .date-of-issue {
    text-align: left;
    align-content: center;
    color: #333; /* Default text color (dark gray for readability) */
  }

  .date-of-issue p:first-child {
    font-weight: bold; /* Make "Date of issue:" bold */
    color: #007bff; /* Blue color for the label */
    font-size: 1.2rem; /* Slightly larger size for the label */
  }

  .date {
    font-size: 1.1rem; /* Slightly larger font size for the date */
    color: #555; /* Lighter gray for the date */
    font-style: italic; /* Italicize the date for contrast */
  }

  h2 {
    text-align: center;
    font-size: 4rem;
    padding-bottom: 3rem;
  }

  .accordion {
    max-width: 800px; /* Adjust the max-width as needed */
    width: 100%; /* Ensure the width fills the container */
  }

  .accordion-item {
    border: 1px solid #ddd;
    margin-bottom: 1.2rem;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }

  .accordion-header {
    background: #2c3e50;
    color: #ecf0f1;
    padding: 1rem;
    font-size: 1.3rem;
    cursor: pointer;
    user-select: none;
    border-radius: 8px;
  }

  .accordion-button {
    font-size: 1.3rem;
    font-weight: 600;
    color: #ecf0f1;
    background: #2c3e50;
    border: none;
    box-shadow: none;
  }

  .accordion-button:not(.collapsed) {
    color: #fff;
    background: #34495e;
  }

  .accordion-body {
    font-size: 1.1rem;
    color: #34495e;
    background: #f4f4f4;
    padding: 1.5rem;
  }

  /* Wrapper for Accordion Header and Course Tag */
  .accordion-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
  }

  /* Style for the course tag */
  .course-tag {
    background-color: #1a8b9d;
    color: #fff;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 600;
    margin-left: 2rem;
  }

  .certificate-tag {
    background-color: #ff894c;
    color: #fff;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 600;
    margin-left: 2rem;
  }

  /* Ensure the design remains responsive */
  @media (max-width: 768px) {
    .accordion-wrapper {
      flex-direction: column;
      align-items: flex-start;
    }

    .course-tag {
      margin-left: 3rem;
      margin-top: 0.5rem;
    }
    .certificate-tag {
      margin-left: 3rem;
      margin-top: 0.5rem;
    }
  }
`;
